import { ModalConfirm } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'

const ModalDisableEditWorkflow = ({ show, onCancel, onConfirm }) => {
  const intl = useIntl()
  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ConfirmDisabledOnEditTitle'
      })}
      message={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ConfirmDisabledOnEditDescription'
      })}
      data-mu-test='disable-edit-workflow'
      closeOnOverlayClick={false}
      showClose={false}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
      onClickConfirm={onConfirm}
      onClickCancel={onCancel}
    />
  )
}
ModalDisableEditWorkflow.propTypes = {
  show: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
}

export default ModalDisableEditWorkflow
